import { createStructuredSelector } from 'reselect';
import {
    DELIVERY_PLAN_AUDIT_LIST,
    DELIVERY_PLAN_AUDIT_LIST_SUCCESS,
    DELIVERY_PLAN_AUDIT_LIST_ERROR,
    DELIVERY_PLAN_AUDIT_MODAL_SET
} from '../../actions';

export const NAME = 'delivery_plan_audit';

export const DeliveryPlanAuditList = (id_delivery_plan) => ({
    type: DELIVERY_PLAN_AUDIT_LIST,
    payload: { id_delivery_plan }
});

export const DeliveryPlanAuditListSuccess = (data) => ({
    type: DELIVERY_PLAN_AUDIT_LIST_SUCCESS,
    payload: data
});

export const DeliveryPlanAuditListError = (error) => ({
    type: DELIVERY_PLAN_AUDIT_LIST_ERROR,
    payload: error
});

export const DeliveryPlanAuditModalSet = (modal) => ({
    type: DELIVERY_PLAN_AUDIT_MODAL_SET,
    payload: modal
});

const delivery_plan_audit = (state) => state[NAME];
export const DeliveryPlanAuditSelector = createStructuredSelector({ delivery_plan_audit });
